module.exports = __webpack_public_path__ + "static/img/column_img_5-2.ef9f31e0.png";